export default __webpack_public_path__ + "static/media/194.cd90ab36.png";